import React from 'react';

export type PeopleTab = 'messages' | 'groups';

interface PeopleMenuBarProps {
  activeTab: PeopleTab;
  onTabChange: (tab: PeopleTab) => void;
  unreadCount?: number;
}

const PeopleMenuBar: React.FC<PeopleMenuBarProps> = ({ activeTab, onTabChange, unreadCount = 0 }) => {
  return (
    <div className="transparent-menu-bar people-menu-bar">
      <button
        className={`menu-tab-btn ${activeTab === 'messages' ? 'active' : ''}`}
        onClick={() => onTabChange('messages')}
      >
        Messages
        {unreadCount > 0 && (
          <span className="menu-badge">{unreadCount}</span>
        )}
      </button>

      <button
        className={`menu-tab-btn ${activeTab === 'groups' ? 'active' : ''}`}
        onClick={() => onTabChange('groups')}
      >
        Sharing
      </button>
    </div>
  );
};

export default PeopleMenuBar;
